import { InMemoryCache } from "@apollo/client";
import { OverlayContext, OverlayList } from "acma-spa/dist/apollo";
import { AccountDetailsFragmentDoc, Acma_Portalsubmission_Statuscode, SubmissionDetailsFragmentDoc, UserDetailsFragmentDoc } from "../__generated__/graphql";

export const overlay = new OverlayContext();
export const accountList = new OverlayList(overlay, AccountDetailsFragmentDoc)
export const userList = new OverlayList(overlay, UserDetailsFragmentDoc)
export const submissionList = new OverlayList(overlay, SubmissionDetailsFragmentDoc)

export const createCache = () => {
  return new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          accounts: {
            keyArgs: ['abn', 'searchText', 'sortColumn', 'sortDesc'],
            merge: (existing, incoming, options) => {
              const { args } = options;
              if (args) {
                const { searchText = '', sortColumn = '', sortDesc = false, limit = 20, abn='' } = args;
                return accountList
                  .isTrue(r => abn ? r.abn == abn : true)
                  .textIsFoundIn(searchText, r => r.name, r => r.accountNumber, r => r.email, r => r.phone)
                  .orderBy(sortColumn, sortDesc)
                  .merge(existing, incoming, options, incoming.length < limit);
              }
              else
                return overlay.mergeObjects(existing, incoming, options);
            }
          },
          account: {
            merge: overlay.mergeObjects
          },
          users: {
            keyArgs: ['abn', 'sortColumn', 'sortDesc'],
            merge: (existing, incoming, options) => {
              const { args } = options;
              if (args) {
                const { sortColumn = '', sortDesc = false, limit = 20 } = args;
                return userList
                  .orderBy(sortColumn, sortDesc)
                  .merge(existing, incoming, options, incoming.length < limit);
              }
              else
                return overlay.mergeObjects(existing, incoming, options);
            }
          },
          user: {
            merge: overlay.mergeObjects,
            read(_, { args, toReference }) {
              return toReference({
                __typename: 'DigitalIdentity',
                id: (args ?? {})['id']
              });
            }
          },
          submissions: {
            keyArgs: ['searchText', 'sortColumn', 'sortDesc', 'completed'],
            merge: (existing, incoming, options) => {
              const { args } = options;
              if (args) {
                const { searchText = '', sortColumn = '', sortDesc = false, limit = 20, completed = true } = args;
                return submissionList
                  .isTrue(r => r.status == Acma_Portalsubmission_Statuscode.Completed ? completed : !completed)
                  .textIsFoundIn(searchText, r => r.keywords)
                  .orderBy(sortColumn, sortDesc)
                  .merge(existing, incoming, { ...options, rowVersionField: "sourceRowVersion" }, incoming.length < limit);
              }
              else
                return overlay.mergeObjects(existing, incoming, { ...options, rowVersionField: "sourceRowVersion" });
            }
          }
        }
      },
    },
  })
}